import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { WhitelabelConfigStore } from '../core/config/whitelabel-config.store';

@Component({
    selector: 'app-aboutus',
    templateUrl: './aboutus.component.html',
    styleUrls: ['./aboutus.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AboutusComponent implements OnInit {
  private readonly defaultStats = [
    { value: '50+', label: 'Buses in service' },
    { value: '100+', label: 'Destinations served' },
    { value: '10M+', label: 'Journeys booked' },
    { value: '22 yrs', label: 'On the road' }
  ];

  private readonly defaultMilestones = [
    { year: '2002', title: 'Mash is founded', body: 'A single long-distance service built on a simple idea — travel that ordinary people can afford.' },
    { year: '2000s', title: 'A national network', body: 'Routes spread from Nairobi to the coast, the lakeside and the border towns.' },
    { year: '2010s', title: 'Across the border', body: 'Cross-border services open into Uganda and Rwanda via Malaba.' },
    { year: 'Today', title: 'Book from anywhere', body: 'Online booking, the Mash Poa app, and mobile-money payment on every ticket.' }
  ];

  private readonly defaultFleetPoints = [
    'Environmentally friendly, modern coaches across the fleet',
    'Speed governors and tracking fitted as standard',
    'Onboard Wi-Fi, air conditioning and charging on select routes',
    'Drivers vetted, trained and monitored on every journey'
  ];

  private readonly defaultDestinations = [
    { city: 'Mombasa', country: 'Kenya', note: 'Coast · overnight & daytime runs', image: 'assets/images/mombasa.webp' },
    { city: 'Malindi', country: 'Kenya', note: 'North coast', image: 'assets/images/malindi.webp' },
    { city: 'Kampala', country: 'Uganda', note: 'Cross-border service', image: 'assets/images/kampala.webp' },
    { city: 'Kigali', country: 'Rwanda', note: 'Cross-border service', image: 'assets/images/kigali.webp' }
  ];

  constructor(public readonly configStore: WhitelabelConfigStore) { }

  get operatorName(): string {
    return this.configStore.getConfig('site.name', 'Bus operator');
  }

  get about(): Record<string, any> {
    return this.configStore.getConfig('content.about', {});
  }

  get stats(): any[] {
    return this.about['stats'] || this.defaultStats;
  }

  get milestones(): any[] {
    return this.about['milestones'] || this.defaultMilestones;
  }

  get fleetPoints(): string[] {
    return this.about['fleetPoints'] || this.defaultFleetPoints;
  }

  get destinations(): any[] {
    return this.about['destinations'] || this.defaultDestinations;
  }

  ngOnInit() {
  }

}
